import React from "react";
import About from "../components/About";

function AboutUs() {
  return (
    <div>
      <About />
    </div>
  );
}

export default AboutUs;
